import {GetterTree} from 'vuex';
import {RootState} from '@/store/type';

export const MainGetters: GetterTree<RootState, RootState> = {
  // getDataAuthToken(state): any {
  //   return localStorage.getItem(AuthEnum.Auth);
  // }
};
